const MODULE = 'TEENDING_SEARCH'

export const FETCH_TRENDING_SEARCH_PENDING = `${MODULE}_FETCH_TRENDING_SEARCH_PENDING`
export const FETCH_TRENDING_SEARCH_SUCCESS = `${MODULE}_FETCH_TRENDING_SEARCH_SUCCESS`
export const FETCH_TRENDING_SEARCH_FAILED = `${MODULE}_FETCH_TRENDING_SEARCH_FAILED`
